import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable, from, throwError } from "rxjs";
import { environment } from "../../../environments/environment";
import { catchError, switchMap, take } from "rxjs/operators";
import { AuthService } from "../../auth/auth.service";

@Injectable()
export class ApiUrlInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return from(this.auth.waitForAuthReady()).pipe(
      switchMap(() => this.auth.getToken().pipe(take(1))),
      switchMap((token: string | null) => {
        const isAbsolute = request.url.startsWith("http");
        const skipRewrite = request.url.startsWith("/assets") || isAbsolute;
        const apiReq = skipRewrite
          ? isAbsolute && token
            ? request.clone({
                setHeaders: { Authorization: `Bearer ${token}` },
              })
            : request
          : request.clone({
              url: `${environment.apiUrl}${request.url}`,
              setHeaders: { Authorization: `Bearer ${token}` },
            });
        return next
          .handle(apiReq)
          .pipe(catchError((e) => this.serviceError(e)));
      }),
    );
  }

  private serviceError(e: unknown) {
    // if (e.status !== 403) {
    //   this.toastr.error(this.translate.instant('error'), e.status?.toString());
    // }
    return throwError(() => e);
  }
}
